export default __webpack_public_path__ + "static/media/burst2.e7c13620.mp3";